import { animated, useSpring } from '@react-spring/three'
import { useTexture } from '@react-three/drei'
import { type JSX, useEffect } from 'react'
import { DoubleSide, MathUtils, SRGBColorSpace } from 'three'

import { BLOCK_CONFIG, BlockType } from '@config'
import { useGameStore } from '@stores'

import { BaseBlock } from './BaseBlock'

type EndBlockProps = JSX.IntrinsicElements['group'] & {
  delay?: number
  isExiting?: boolean
}

export function EndBlock({ delay, isExiting, ...props }: EndBlockProps) {
  const isLevelCompleted = useGameStore(state => state.isLevelCompleted)
  const sprite = useTexture('/sprites/cave.png')

  useEffect(() => {
    sprite.colorSpace = SRGBColorSpace
    sprite.needsUpdate = true
  }, [sprite])

  const { opacity } = useSpring({
    opacity: isLevelCompleted ? 1 : 0.5,
    config: { mass: 1, tension: 280, friction: 20 },
  })

  return (
    <group {...props}>
      <BaseBlock color={BLOCK_CONFIG[BlockType.End].color} delay={delay} isExiting={isExiting}>
        <mesh
          rotation={[MathUtils.degToRad(-35), 0, MathUtils.degToRad(-10)]}
          position-y={0.6}
          position-z={0.1}
          renderOrder={0}
        >
          <planeGeometry />
          {/* @ts-ignore */}
          <animated.meshBasicMaterial
            map={sprite}
            transparent
            side={DoubleSide}
            depthTest={false}
            depthWrite={false}
            opacity={opacity}
          />
        </mesh>
      </BaseBlock>
    </group>
  )
}

useTexture.preload('/sprites/cave.png')
